package kpt.core.database

import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Suppress

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class AppDatabase_AutoMigration_12_13_Impl : Migration {
  public constructor() : super(12, 13)

  public override suspend fun migrate(connection: SQLiteConnection) {
    connection.execSQL("ALTER TABLE `framework_submit_drafts` ADD COLUMN `attemptCount` INTEGER NOT NULL DEFAULT 0")
  }
}
